export enum DtgSidebarView {
    side = 'side',
    bottom = 'bottom',
}
